module.exports = __webpack_public_path__ + "static/3-6a9f9dba4777f59774592a8bd18173c7.png";